import { Button } from '@mui/material';
import { Row } from '../Row';
import './Breadcrumb.scss';
import { useNavigate } from 'react-router-dom';
import { Icon } from '../Icon';

export const Breadcrumb = ({ action }) => {
    const navigate = useNavigate();

    return (
        <Row className="Breadcrumb">
            <Button className='Breadcrumb-Path' variant="text" onClick={() => navigate(-1)}>
                <Icon name="less-than" size={12} />
                <span>Back</span>
            </Button>
            {action}
        </Row>
    );
};